import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import EditCoupon from "../../../components/SuperAdmin/Coupon/EditCoupon";

export default withRouter(connect()(EditCoupon));
